import { Config } from '../../common/src/config.js';
import { Environment } from '../../common/src/environment.js';
import { ScriptManagement } from '../../common/src/scriptManagement.js';

// womtp - namespace init
var womtp = womtp || {};
if (typeof wm_env === 'undefined') wm_env = 'c'; 
(function (factory) {
    // Código de inicialización: config y carga de archivos
    var c = new Config({
        testFileName: 'det',
        testUrlParam: 'debugDET',
        testIframeUrl: '//ws.walmeric.com/static/dft/test/v1/det.js',
        testIframeParams: ' ',
        preReleaseFileName: 'det',
        preReleaseUrlParam: 'debugPreDET',
        preReleaseIframeParams: ' ',
        preReleaseIframeUrl: '//ws.walmeric.com/static/dft/preRelease/v1/det.js'
    });
    var e = new Environment();
    var sm = new ScriptManagement();
    
    // Entorno: producción o integración 
    e.setEnvironmentVar(c.get('testFileName'));
    // Comprobamos si queremos sustituir este script con el de /test/
    e.setDebugMode(c.get('testUrlParam'));
    if (e.getDebugMode(c.get('testUrlParam')) && !sm.checkTestScript(c.get('testFileName'))) {
        
        sm.loadScriptDelayingCallback(c.get('testIframeUrl'), c.get('testFileName'), c.get('testIframeParams'));
        return;
    }
    //Entorno: Producción o PreRelease
    // Entorno: producción o integración 
    e.setEnvironmentVar(c.get('preReleaseFileName'));
    // Comprobamos si queremos sustituir este script con el de /test/
    e.setDebugMode(c.get('preReleaseUrlParam'));
    if (e.getDebugMode(c.get('preReleaseUrlParam')) && !sm.checkTestScript(c.get('preReleaseFileName'))) {
        sm.loadScriptDelayingCallback(c.get('preReleaseIframeUrl'), c.get('preReleaseFileName'), c.get('preReleaseIframeParams'));
        return;
    }

    if (!window.DAL) {
        var s = document.createElement("script");
        s.src = "https://ws.walmeric.com/static/dft/dist/v1/dal.js";
        document.querySelector("head").appendChild(s);
    }
    if (!window.DET) {
        var cargaDAL = setInterval(function(){
            //console.log("esperando carga de DAL");
            if(window.DAL){
                clearInterval(cargaDAL);
                window.DET = {};
                factory();
            }
        }, 1000); 
    }


})(function(){

    //obj es un objeto que tiene que tener un valor en obj.clave y tieneun valor opcional de obj.webservice
    DET.init = function(obj, callbackInit){
        var callbackInit = callbackInit;
        var piwik = setInterval(function(){
            if(getCurrentPixel()){
                clearInterval(piwik);
                
                var bk = false;
                var objBk;
                var ga = false;
                var objGa;
                var adf = false;
                var objAdf;

                //comprobamos el objeto de estados globales
                if(!statusDFI){
                    statusDFI = {}
                }
                //comprobamos el objeto de estados que indicara si esta permitido enviar el id a esa pasarela

                if(typeof statusDFI.loadPlatformsIds === 'undefined')
                    statusDFI.loadPlatformsIds = { 'bkid':  false, 'gaid': false, 'adfid':  false, 'dcuserid': false, 'gclid': false, 'delioid': false, 'sizid': false, 'weboid': false, 'msclkid': false, 'kid': false, 'mcvid': false, "visitScoring": false, 'matchId': false, 'fbPixel': false, 'fbclid': false  };
                
                //creamos objeto que cuando se lanza un id no permite que se envie mas veces
                if(typeof statusDFI.plataformSendId === 'undefined'){
                    statusDFI.plataformSendId = {};
                }

                //si no esta declarado un id en el array ni se comprueba ni se envia
                //si el id esta definido y la propiedad send es false actualizamos el objeto loadPlatformsIds
                //comprobamos si esta definido el array de estados definida en el obj de entrada
                //recoremos el objeto proviniente del cliente

                for(let key in obj){

                    //id de la pasarela
                    const id = obj[key].id

                    //comprobamos si la pasarlea declarada por el usuario esta soportada y quiere enviar 
                    if(statusDFI.loadPlatformsIds === true || statusDFI.loadPlatformsIds[id]){

                        //seteamos a true la propiedad que permitira el envio del id de la pasarela
                        statusDFI.loadPlatformsIds[id] = true;

                    }
                }
                var idsIntervals ={};
                function saveIdInterval(idObj, idInterval){
                    idsIntervals[idObj] = idInterval;
                }
                function stopIdInterval(idObj){
                    clearInterval(idsIntervals[idObj])
                }
                var centinela = {};
                function executePayload(ctxObj){
                    //si centinela inferior al limite retries ejectuamos  sino limpiamos y no hacemos nada mas.
                    if(typeof centinela[ctxObj.id] === 'undefined')
                        centinela[ctxObj.id] = 0;

                        
                    if(statusDFI.loadPlatformsIds[ctxObj.id] === true || statusDFI.loadPlatformsIds === true){
                        console.log('check condition if send: ',ctxObj.id, ': ',centinela[ctxObj.id] < ctxObj.retries && statusDFI.plataformSendId[ctxObj.id] !== ctxObj.value )
                        
                        //comprobamos si esta dentro del limite de envios y comprobamos que no se haya enviado ya
                        if(centinela[ctxObj.id] < ctxObj.retries && statusDFI.plataformSendId[ctxObj.id] !== ctxObj.value ){
                            statusDFI.plataformSendId[ctxObj.id] = true;
                            check(ctxObj, function(keyNameAndId){
                                if(keyNameAndId){
                                    init(keyNameAndId, undefined, function(){
                                        console.log('set id for not send other request for same id: ',ctxObj.id)
                                        statusDFI.plataformSendId[ctxObj.id] = ctxObj.value;
                                        ctxObj.callbackFunction(ctxObj);
                                        stopIdInterval(ctxObj.id); 
                                        
                                    })
                                }else{
                                    centinela[ctxObj.id]++;
                                    statusDFI.plataformSendId[ctxObj.id] = false;
                                }
                            })
                        }else{
                            stopIdInterval(ctxObj.id);
                        }
                    }
                }
                var checkObjComplete = []
                function process_plataforms(ctxObj){
                    checkObjComplete.push(ctxObj)
                    if(obj.length === checkObjComplete.length ){
                        callbackInit()
                    }
                }
                for(var e=0; e<obj.length; e++){
                
                    //si existen estas 3 propiedades ejecutamos el nuevo codigo  sino lo hacemos como antes
                    //ejemplo con los nuevos parametros: { id : "ga" , value: 'xxxxxxxxxxxxxxxxxxx', retries: 20, setInterval: 2000}
                    /*
                        statusDFI.loadPlatformsIds = {ga: false};
                        var data = [
                            { id : "ga" ,value: 'testingSending', retries: 40, setInterval: 500}, ok, -, ok
                            { id: 'dcuser', value: 'dcuserTestValue',retries: 20, setInterval: 500 }, ok, +, ok
                            { id: "gcl", value: 'gclTestValue', retries: 500, setInterval:1000}, ok, -, ok
                            { id: 'bk', value: 'bkTestValue', retries: 400, setInterval: 500}, ok, +, ok
                            { id: 'delio', value: 'delioTestValue', retries: 200, setInterval: 2000}, ok, -, ok
                            { id: 'siz', value: 'sizTestValue', retries: 500, setInterval: 500}, ok, +, ok
                            { id: 'webo', value: 'weboTestValue', retries: 500, setInterval: 1000}, ok, -, ok
                            { id: 'mcv', value: 'mcvTestValue', retries: 20, setInterval: 5000}, ok, +, ok
                            { id: 'k', value: 'kTestValue', retries: 40, setInterval: 2000}, ok, -, ok
                            { id: 'adf', value: 'adfTestValue', retries: 40, setInterval: 500}, ok, +, ok
                            { id: 'fbcl', value: 'fbclTestValue', retries: 40, setInterval: 500}, ok, -, ok
                            { id: 'fbPixel', value: 'fbPixelTestValue', retries: 50, setInterval: 500}, ok, +, ok
                            { id: 'msclk', value: 'msclkTestValue', retries: 20, setInterval: 500}, ok, -, oknpm  
                            { id: 'match', value: 'matchTestValue', retries: 20, setInterval: 500}, ok, +, ok
                            { id: 'visitScoring', value: 'visitScoringTestValue', retries: 20, setInterval: 500}, ok, -, ok 
                        ]

                        DET.init(data);
                    */
                    if(obj[e].value && obj[e].setInterval && obj[e].retries){
                        console.log('enter the new code: ', obj[e].id)
                        //nombre de la pasarela
                        const id = obj[e].id;
                        
                        //comprobamos si statusDFI.loadPlatformsIds[id] permite el envio.
                        //por motivos de seguridad solo funciona para las nuevas propiedades
                        obj[e].callbackInit = process_plataforms;
                        obj[e].callbackFunction = function(ctxObj){
                            stopIdInterval(ctxObj.id);
                            if(ctxObj.callbackInit === 'function')
                                ctxObj.callbackInit(obj[e]);
                        }                      
                        var intrval = setInterval(executePayload, obj[e].setInterval, obj[e]) 
                        saveIdInterval(id, intrval);
                    }else if(typeof obj[e].function === 'function' ){
                        console.log('enter in new code for function: ', obj[e].id)
                        //comprobamos que el valor que se va a pasar a la funcion como parametro  no es undefined no es 1 === el valor lo gestiona la funcion
                        // y es diferente de '' vacio
                        if(typeof obj[e].value !== 'undefined' && obj[e].value !== 1 && obj[e].value !== ''){
                            //hacemos que la funcion tenga el contexto de obj[e].function y añadimos el parametro value para que cuando ejecute la funcion tenga el parametro insertado.
                            obj[e].function = obj[e].function.bind(obj[e].function, obj[e].value);
                        }
                        //aqui se ejecuta la funcion con o sin parametros, cuando value no es vacio, se añade aqui 
                        obj[e].function();
                    }else{
                        console.log('retrocompatibilidad: ', obj[e].id);
                        
                        if (obj[e].id == "bk") {
                            var bk = true;
                            objBk = obj[e];
                        } else if (obj[e].id == "ga") {
                            var ga = true;
                            objGa = obj[e];
                        } else if (obj[e].id == "adf") {
                            var adf = true;
                            objAdf = obj[e];
                        }
                        if(bk === true){
                            checkBk(objBk, function(valBk){
                                initBk(valBk, objBk.url, function(){
                                    if(callbackInit){
                                        callbackInit();
                                    }
                                });
                            });
                        }
        
                        if(ga === true){
                            checkGa(objGa, function(valGa){
                                initGa(valGa, objGa.url, function(){
                                    if(callbackInit){
                                        callbackInit();
                                    }
                                });
                            });
                        }
                        if(adf === true){
                            checkAdf();
                        }
                    }
                }
                
                
                //obtenemos si tenemos que recoger de forma asincrona el valor de cada servicio
                /*for(var e=0; e<obj.length; e++){
                    if (obj[e].id == "bk") {
                        var bk = true;
                        objBk = obj[e];
                    } else if (obj[e].id == "ga") {
                        var ga = true;
                        objGa = obj[e];
                    } else if (obj[e].id == "adf") {
                        var adf = true;
                        objAdf = obj[e];
                    }
                }

                if(bk === true){
                    checkBk(objBk, function(valBk){
                        initBk(valBk, objBk.url, function(){
                            if(callbackInit){
                                callbackInit();
                            }
                        });
                    });
                }

                if(ga === true){
                    checkGa(objGa, function(valGa){
                        initGa(valGa, objGa.url, function(){
                            if(callbackInit){
                                callbackInit();
                            }
                        });
                    });
                }

                if(adf === true){
                    checkAdf();
                }*/

            } 
        }, 100);
    };
    function check(obj, callback){
        //comprobamos que el valor de la plataforma existe
        if(typeof obj.value !== 'undefined'){
            const auxObj = {};
            //asignamos la clave como el id osea ga concatenado con el str id === gaid
            auxObj[obj.id] = obj.value
            callback(auxObj)
        }else{

            callback(false);
        }

        
    }
    function getDataAbstractData(obj){

        return {        
            idsite: getCurrentPixel().getAsyncTracker().getSiteId(),
            idvisitor: getCurrentPixel().getAsyncTracker().getVisitorId(),
            v: '1',
            ...obj  
        }
    }
    function init(objAndId, webservice, callback){
        var url;
        if (typeof(webservice) != "undefined"){
           url = webservice;
        } else {
           url = 'https://t.womtp.com/epst/v2';
        }
        //solicitud para actualizar el back 
        DAL.Ajax({
            type: 'jsonp',
            url: url,
            data: getDataAbstractData(objAndId)
        }).done(function() {
            callback();
        }).fail(function(){
            console.error('')
        })
    }
    function getCurrentPixel(){
        if (window.womtp && window.womtp.getAsyncTracker) {
            return window.womtp;
        } else if (window.Piwik && window.Piwik.isDelio) {
            return window.Piwik;
        }
    }

    function initBk(bkId, webservice, callbackBk){
        var url;
        if (typeof(webservice) != "undefined"){
           url = webservice;
        } else {
           url = (wm_env === 'c' || wm_env === 'd') ? 'https://t.womtp.com/epst/v2' : 'https://int.womtp.com/epst/v2';
        }

        //solicitud para actualizar el back 
        DAL.Ajax({
            type: 'jsonp',
            url: url,
            data: {
                idsite: getCurrentPixel().getAsyncTracker().getSiteId(),
                idvisitor: getCurrentPixel().getAsyncTracker().getVisitorId(),
                v: "1",
                bkid: bkId
            }
        }).done(function() {
            callbackBk();
        }) 
    }

    function initGa(idAnalytics, url, callbackBk){
        var url;
        if (typeof(webservice) != "undefined"){
           url = webservice;
        } else {
           url = (wm_env === 'c' || wm_env === 'd') ? 'https://t.womtp.com/epst/v2' : 'https://int.womtp.com/epst/v2';
        }

        //solicitud para actualizar el back 
        DAL.Ajax({
            type: 'jsonp',
            url: url,
            data: {
                idsite: getCurrentPixel().getAsyncTracker().getSiteId(),
                idvisitor: getCurrentPixel().getAsyncTracker().getVisitorId(),
                gaid: idAnalytics,
                v: "1"
            }
        }).done(function() {
            callbackBk();
        }) 
    }
    
    function checkBk(obj, callback){

        var varName;//opcional
        try {
            varName = obj.varName;
        } catch (error) {}

        var source;//opcional
        try {
            source = obj.source;
        } catch (error) {}

        var valId;//opcional con varName y source
        //Hasta que no se obtenga valId no se llama al webservice para evitar vacios
        var intervalBk = setInterval(function(){
            if (typeof(varName) != "undefined" && typeof(source) != "undefined") {
                valId = getValId(source, varName);
            } else {
                valId = window.walmericBkuuid;
            }
            
            if(typeof(valId) != "undefined"){
                clearInterval(intervalBk);
                callback(valId);
            }
        },200)
        
    }

    function checkGa(obj, callback){

        var varName;//opcional
        try {
            varName = obj.varName;
        } catch (error) {}

        var source;//opcional
        try {
            source = obj.source;
        } catch (error) {}

        var valId;//opcional con varName y source
        //Hasta que no se obtenga valId no se llama al webservice para evitar vacios
        var intervalGa = setInterval(function(){
            if (typeof(varName) != "undefined" && typeof(source) != "undefined") {
                valId = getValId(source, varName);
            } else {
                valId = getCookie("_ga");
            }
            
            if(valId){
                clearInterval(intervalGa);
                callback(valId);
            }
        },200)
        
    }

    function getValId (source, varName){
        var valId;
        if (source == "window") {
            valId = window[varName];
        } else if (source == "cookie") {//sin probar
            valId = getCookie(varName);
        } else if (source == "sessionStorage"){
            valId = sessionStorage.getItem(varName);
        } else if (source == "localStorage"){
            valId = localStorage.getItem(varName);
        }else{
            valId = false;
        }
        return valId
    }


                 //////////////////////
            ///////Obtener una cookie///////
                 /////////////////////

    getCookie = function(c_name){
        var i,x,y,ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
            x = x.replace(/^\s+|\s+$/g,"");
            if (x === c_name)
                return decodeURIComponent(y);
        }
        return false;
    };

});